import React, { useState, useEffect } from 'react';
import SolicitationDetailsComments from '../../../Solicitations/SolicitatonsList/SolicitationDetails/SolicitationDetailsComments';

interface Props {
    row: any,
    reloadComments?: boolean,
    changeReloadComments?: Function
    tab?: number
}

const AttendanceDetailsComments: React.FC<Props> = (props) => {

    return (
        <SolicitationDetailsComments
            solicitation={props.row}
            tab={props.tab}
            showIconAttendant={true}
            attendant={true}
            reloadComments={props.reloadComments}
            changeReloadComments={props.changeReloadComments}
        />
    );
};

export default AttendanceDetailsComments;